import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import {
  AppNotifications,
  FocusedMarketStatus,
  FORM_MODE,
  RootState,
  FocusedMarketInputModel,
  TCb,
  UploadedImageModel,
  LanguageOutputModel,
  FocusedMarketOutputModel
} from "../../../../../models";
import { FocusedMarketService } from "../../../../../services";
import { NotificationActions, AllLanguageListActions } from "../../../../../store/actions";
import FocusedMarketFormPresenter from "./FocusedMarketForm.presenter";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./FocusedMarketForm.type";
import { v4 as uuidv4 } from "uuid";
import { ImageUtil, loadCallback } from "../../../../../utils";
import { withRouter } from "react-router-dom";

class FocusedMarketFormContainer extends Component<MergedProps, C_States> {
  constructor(props) {
    super(props);

    this.state = {
      mode: FORM_MODE.CREATE,
      loading: false,
      initData: null,

      focusedMarketStatus: {
        status: false,
        timePublication: null,
        isPublish: false
      },

      focusedMarketContent: {},
      newFocusedMarketContent: null,

      focusedMarketPictures: [],
      languageData: this.props.all_language_list.data,
      activeLanguageId: this.props.all_language_list.data.find((e: LanguageOutputModel) => e.isPrimary)?.id,
      filter: {
        code: ""
      },
      bannerImage: "",
      focusedMarketDetail: null
    };
  }

  onChangeLanguage = (languageId: string) => {
    this.setState({
      activeLanguageId: languageId
    });
  };

  onUploadBanner = (data: UploadedImageModel) => {
    const formData = new FormData();
    formData.append("image", data.file);
    FocusedMarketService.uploadImageFocusedMarketPage(formData)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.setState({
            focusedMarketPictures: [
              { id: uuidv4(), src: ImageUtil.buildFocusedMarketImgSrc(res.data.data)!, alt: data.alt || "" },
            ],
          });
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload image failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload image failed" });
      });
  };

  onRemoveBanner = (fileId: string) => {
    const banners = this.state.focusedMarketPictures.filter((p) => p.id !== fileId);
    this.setState({
      focusedMarketPictures: banners,
    });
  };

  onChangeFocusedMarketStatus = (status: boolean) => {
    this.setState((prevState) => {
      return {
        focusedMarketStatus: {
          ...prevState.focusedMarketStatus,
          status,
        },
      };
    });
  };

  onChangeShowPublishTime = (isPublish: boolean) => {
    this.setState((prevState) => {
      return {
        focusedMarketStatus: {
          ...prevState.focusedMarketStatus,
          isPublish,
        },
      };
    });
  };

  onChangeTimePublication = (date: string | null) => {
    this.setState((prevState) => {
      return {
        focusedMarketStatus: {
          ...prevState.focusedMarketStatus,
          timePublication: date,
          isPublish: date ? true : false,
        },
      };
    });
  };

  onUploadContentImgHandler() {
    const self = this as any;
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files![0];
      const formData = new FormData();

      formData.append("image", file);
      // Save current cursor state
      const range = self.quill.getSelection(true);
      // Insert temporary loading placeholder image
      // quill.insertEmbed(range.index, "image", `${window.location.origin}/images/loaders/placeholder.gif`);

      // Move cursor to right side of image (easier to continue typing)
      self.quill.setSelection(range.index + 1, 1);

      const res = await FocusedMarketService.uploadImageFocusedMarketPage(formData);

      // Remove placeholder image
      // quill.deleteText(range.index, 1);

      if (res && res.status === 201) {
        self.quill.insertEmbed(range.index, "image", ImageUtil.buildFocusedMarketImgSrc(res.data.data));
      }
    };
  }

  onChangeFocusedMarketContent = (val: any, langId: string) => {
    this.setState(prev => {
      return {
        focusedMarketContent: {
          ...prev.focusedMarketContent,
          [langId]: val
        }
      }
    });


  };

  onSubmit = (val: any) => {
    if (!this.state.focusedMarketPictures.length) {
      this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Please upload an image" });
      return;
    }

    if (!this.state.focusedMarketContent) {
      this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Please input content" });
      return;
    }

    const banner = this.state.focusedMarketPictures[0];

    let data: FocusedMarketInputModel[] = [];

    this.state.languageData.forEach((lang) => {
      if (val[`title${lang.id}`]) {
        let dataObj: any = {
          title: val[`title${lang.id}`],
          featureImage: ImageUtil.convertImgServerSrc(banner.src, "focusedMarket"),
          status: this.state.focusedMarketStatus.status ? FocusedMarketStatus.PUBLISH : FocusedMarketStatus.UNPUBLISH,
          publishDate: this.state.focusedMarketStatus.timePublication,
          isPublish: this.state.focusedMarketStatus.isPublish,
          description: this.state.focusedMarketContent[lang.id],
          shortDescription: val[`shortDescription${lang.id}`],
          languageId: lang.id,
        }
        // dataObj = _.pickBy(dataObj, (v) => !_.isUndefined(v));
        const found = this.state.initData?.find((i) => i.languageId === lang.id) || false;
        this.state.mode !== FORM_MODE.CREATE &&
          found &&
          Object.assign(dataObj, {
            id: this.state.initData?.find((i) => i.languageId === lang.id)?.id,
          });
        data.push(dataObj);
      }
    })

    if (this.state.mode === FORM_MODE.CREATE) {
      this.onCreateFocusedMarket(data);
    }
    else {
      this.onUpdateFocusedMarket(data);
    }
  };

  onLoadAllFocusedMarketDetail = (focusedMarketPageCode: string, cb?: TCb) => {
    this.setState({ loading: true, initData: null }, () => {
      FocusedMarketService.getFocusedMarketPage(focusedMarketPageCode)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            const data: FocusedMarketOutputModel[] = res.data.data;

            data.forEach((item) => {
              const banner = item.featureImage
                ? {
                  id: item.id,
                  src: ImageUtil.buildFocusedMarketImgSrc(item.featureImage)!,
                  alt: item.featureImage || "",
                }
                : undefined;

              this.setState({
                focusedMarketPictures: banner ? [banner] : [],
                focusedMarketStatus: {
                  status: item.status === FocusedMarketStatus.PUBLISH,
                  timePublication: item.publishDate,
                  isPublish: item.isPublish
                },
                // newFocusedMarketContent: item.description,
              })
            });

            this.setState(
              {
                mode: FORM_MODE.EDIT,
                focusedMarketDetail: data,
                initData: data,
                loading: false,
                focusedMarketContent: data.reduce((res, item) => {
                  return {
                    ...res, [item.languageId]: item.description
                  }
                }, {})
              },
              () => {
                loadCallback(cb?.success);
              }
            );
          }
          else {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Load data failed",
            });
            this.props.history.goBack();
          }
        })
        .catch((err) => {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Load data failed",
          });
        });
    });
  };

  onCreateFocusedMarket = (data) => {
    FocusedMarketService.createFocusedMarketPage(data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Create focused market success",
          });
          loadCallback(this.props.onComplete_Create);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create focused market failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create focused market failed" });
      });
  };

  onUpdateFocusedMarket = (data) => {
    FocusedMarketService.updateFocusedMarketPage(this.props.focusedMarketPageCode!, data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Edit focused market ",
          });
          loadCallback(this.props.onComplete_Update);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Edit focused market failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Edit focused market failed" });
      });
  };

  componentDidMount = () => {
    if (this.props.focusedMarketPageCode) {
      // this.onLoadFocusedMarketDetail(this.props.focusedMarketPageCode);
      this.onLoadAllFocusedMarketDetail(this.props.focusedMarketPageCode);
    }
  };

  render() {
    return (
      <FocusedMarketFormPresenter
        {...this.props}
        {...this.state}
        onUploadBanner={this.onUploadBanner}
        onRemoveBanner={this.onRemoveBanner}
        onChangeLanguage={this.onChangeLanguage}
        onChangeFocusedMarketStatus={this.onChangeFocusedMarketStatus}
        onChangeTimePublication={this.onChangeTimePublication}
        onChangeShowPublishTime={this.onChangeShowPublishTime}
        onUploadContentImgHandler={this.onUploadContentImgHandler}
        onChangeFocusedMarketContent={this.onChangeFocusedMarketContent}
        onSubmit={this.onSubmit}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions, AllLanguageListActions), dispatch),
    })
  )(FocusedMarketFormContainer)
);
